module.exports = __webpack_public_path__ + "img/majorroadway.22d01dda.svg";